import { render, staticRenderFns } from "./categoryTemplate.vue?vue&type=template&id=a2cdc30a"
import script from "./categoryTemplate.vue?vue&type=script&lang=js"
export * from "./categoryTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports